import styled from 'styled-components';

export const HeaderRowStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  margin-top: 20px;
`;

export const HeaderRowTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  font-family: ${(props) =>
    props.theme.isVaultVariant
      ? "'Rubik'"
      : "'Plus Jakarta Sans', ui-sans-serif, system-ui, sans-serif"};
  margin: 0;
`;
